jQuery(document).ready(function ($) {
    var $trigger = $('.search-icon');
    var $overlay = $('.page-search');
    var $close   = $('#close-search-form');
    var $input   = $('#search-site');
    var $body    = $('body');

    if (!$trigger.length || !$overlay.length) return;

    function openSearch(e) {
        if (e) e.preventDefault();
        $overlay.addClass('open');
        $body.addClass('no-scroll');
        $trigger.attr('aria-expanded', 'true');
        setTimeout(function () { $input.trigger('focus'); }, 150);
    }

    function closeSearch(e) {
        if (e) e.preventDefault();
        $overlay.removeClass('open');
        $body.removeClass('no-scroll');
        $trigger.attr('aria-expanded', 'false');
    }

    $trigger.on('click', openSearch);
    $close.on('click', closeSearch);
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $overlay.hasClass('open')) {
            closeSearch();
        }
    });
});
